import React from "react";
import classNames from "classnames";
import { normalizeNum, numberWithSpaces } from "../../../utils";
import Icon from "../../Icon/Icon";
import Chips from "../../Chips/Chips";

import upIcon from "icons/up.svg";

export default class Bet extends React.PureComponent {
  render() {
    const { username, sum, cf = null, closed = false } = this.props;

    return (
      <div className="crash-bet">
        <span className="crash-bet__player">{username}</span>
        <div className="crash-bet__sum-block">
          <span className="crash-bet__sum">{numberWithSpaces(normalizeNum(sum))} R</span>
        </div>
        <div className="crash-bet__chips-block">
          <Chips value={sum} round={true} />
        </div>

        <div className="crash-bet__win-block">

          {closed && (
            <div className="crash-bet__win-chips">
              <Chips value={sum * cf} key={1} />
            </div>
          )}

          {closed && (
            <div className="crash-bet__cf text-icon">
              <Icon glyph={upIcon} className="text-icon__icon" />
              <span>{normalizeNum(cf)}x</span>
            </div>
          )}

          <div className="crash-bet__win-sum">
            {closed && (
              <span key={1}>{numberWithSpaces(Math.floor(sum * cf))} R</span>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/CrashGame/Bet/Bet.jsx